import { useFeatureFlagEnabled } from '@posthog/react';
import { Outlet } from 'react-router';

import ConnectOutlook from '@/components/common/ConnectOutlook';
import LoadingPage from '@/components/common/LoadingPage';
import useOutlookConnection from '@/features/settings/queries/hooks/useOutlookConnection';
import useAuth from '@/hooks/useAuth';

export default function EmailLayout() {
  const { isLoading: isAuthLoading } = useAuth();

  const { isPending: isOutlookConnectionPending, data: outlookConnection } =
    useOutlookConnection();

  const isOutlookMandatory = useFeatureFlagEnabled('outlook-sso-mandatory');

  if (isAuthLoading || isOutlookConnectionPending) return <LoadingPage />;

  if (isOutlookMandatory && !outlookConnection?.connected)
    return <ConnectOutlook />;

  return <Outlet />;
}
